import { EntityWithId, EntityWithIdAndDescription } from 'src/types'

export const SectorComercialViewDTOFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    Nombre: 'nombreSectorComercial'
} as const

export type SectorComercialViewDTO = EntityWithId & {
    [SectorComercialViewDTOFields.CodPais]: number
    [SectorComercialViewDTOFields.Nombre]: string
    [SectorComercialViewDTOFields.NombrePais]: string
}

export const SectorComercialGrupoViewDTOFields = {
    IdGrupo: 'idGrupo',
    NombreGrupo: 'nombreGrupo',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodSistema: 'codSistema',
    NombreSistema: 'nombreSistema',
    PerteneceAGrupo: 'perteneceAGrupo'
} as const

export type SectorComercialGrupoViewDTO = {
    [SectorComercialGrupoViewDTOFields.IdGrupo]: number
    [SectorComercialGrupoViewDTOFields.NombreGrupo]: string
    [SectorComercialGrupoViewDTOFields.CodPais]: number
    [SectorComercialGrupoViewDTOFields.NombrePais]: string
    [SectorComercialGrupoViewDTOFields.CodSistema]: number
    [SectorComercialGrupoViewDTOFields.PerteneceAGrupo]: boolean
}

export const SectorComercialGruposFilterDTOFields = {
    CodsMensajeTipo: 'codsMensajeTipo',
    CodsPais: 'codsPais'
} as const

export type SectorComercialGruposFilterDTO = {
    [SectorComercialGruposFilterDTOFields.CodsMensajeTipo]?: number[]
    [SectorComercialGruposFilterDTOFields.CodsPais]?: number[]
}
